import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

function ShippingPolicy() {
  return (
    <div>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container'>
        <h3 className='text-center my-5'>
          <b>POLÍTICA DE ENVÍO</b>
        </h3>
        <p className='my-5 text-justify'>
          Los artículos que se ofrecen a través de esta página web están
          únicamente disponibles para su envío dentro de la Provincia de Madrid.
        </p>
        <p className='my-3'>Los gastos de envío de su pedido son:</p>
        <li>Gratis en compras superiores a 200 euros.</li>
        <li>5,95 euros en compras inferiores a 200 euros.</li>
        <p className='my-5 text-justify'>
          La entrega de productos y servicios corre a cargo de MRW, se realiza
          en un plazo de 2-5 días laborables, una vez recibido el email de
          confirmación de disponibilidad. Este plazo aplicará igualmente a los
          pedidos que sean recogidos en tienda. Tenga en cuenta, en cualquier
          caso, que también se realizan entregas a domicilio los sábados y que
          las recogidas en tienda comprenden los sábados en horario de 10:00 a
          13:30 horas.
        </p>
        <p className='my-5 text-justify'>
          Si se produjeran dificultades en cuanto al suministro de productos o
          si no quedan artículos en stock una vez realizado su pedido, se le
          notificaría via email o teléfono, y se procederá al reembolso de
          cualquier cantidad que pudiera usted haber abonado en el mismo medio
          de pago utilizado en la compra.
        </p>
        <p className='my-5 text-justify'>
          Tenga en cuenta que existen circunstancias derivadas de la
          personalización de los productos, o circunstancias imprevistas o
          extraordinarias que pueden afectar a la fecha de entrega.
        </p>
        <p className='my-5 text-justify'>
          Si por algún motivo no pudiésemos cumplir con la fecha de entrega, le
          informaremos de esta circunstancia y le daremos la opción de seguir
          adelante con la compra estableciendo una nueva fecha de entrega o bien
          anular el pedido con el reembolso total del precio pagado.
        </p>
        <p className='my-5 text-justify'>
          Deberá asegurarse de que el día de la entrega alguien pueda firmar el
          recibo de entrega del pedido. No nos responsabilizamos de las
          incidencias de entrega ocasionadas por errores o falta de información
          sobre el destinatario o el lugar de entrega del pedido. Le corresponde
          a usted facilitarnos con exactitud todas las precisiones necesarias
          para el envío correcto de su paquete.
        </p>
        <p className='my-5 text-justify'>
          Si nos resulta imposible efectuar la entrega de su pedido,
          intentaremos buscar un lugar seguro para dejarlo. Si no podemos
          encontrar un lugar seguro, su pedido será devuelto a nuestro almacén.
          Asimismo, le dejaremos una nota explicándole dónde se encuentra su
          pedido y cómo hacer para que le sea enviado de nuevo. Si no va a estar
          en el lugar de entrega a la hora convenida, le rogamos que se ponga en
          contacto con nosotros para convenir la entrega en otro día. Toda la
          información se la proporcionará la empresa MRW y podrá hacer dicho
          seguimiento una vez el pedido haya salido de nuestro almacén.
        </p>
        <p className='my-5 text-justify'>
          En caso de que el pedido no haya sido entregado por causa no imputable
          a nosotros, nos pondremos en contacto con usted y, si transcurridos
          treinta (30) días desde que pongamos el artículo a su disposición no
          lo hubiera recogido o se negase a recibirlo, se tendrá por abandonado.
          Para obtener más información, puede contactar con nosotros a través de
          nuestros canales de Atención al Cliente:
        </p>
        <p className='my-5 text-justify'>
          Llamar al <b className='ms-2'>91 404 51 09</b>
        </p>
        <p className='my-5 text-justify'>
          Notificarlo en el Formulario de <b>"Contacto"</b>
        </p>
        <p className='my-5 text-justify'>
          Escribiendo a:{' '}
          <a
            href={`mailto: deportessporting@gmail.com`}
            style={{ color: 'blue' }}
          >
            deportessporting@gmail.com
          </a>
        </p>
      </div>

      <Footer />
    </div>
  );
}

export default ShippingPolicy;
